import styled from '@emotion/styled';

export const MarkdownTable = styled.table`
    border-collapse: collapse;
    width: 100%;
`;
export const MarkdownTableTh = styled.th`
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
    background-color: #f5f5f5;
`;
export const MarkdownTableTd = styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
`;
